import { render } from "./ModalConfirm.vue?vue&type=template&id=54ecb192&scoped=true"
import script from "./ModalConfirm.vue?vue&type=script&lang=js"
export * from "./ModalConfirm.vue?vue&type=script&lang=js"

import "./ModalConfirm.vue?vue&type=style&index=0&id=54ecb192&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ecb192"]])

export default __exports__